import { h as i } from "vue";
import { NMenuOptionGroup as m, menuItemGroupProps as d } from "./ghl-ui.es1367.js";
import { NSubmenu as y, submenuProps as a } from "./ghl-ui.es1046.js";
import { NMenuOption as b, menuItemProps as h } from "./ghl-ui.es1368.js";
import O from "./ghl-ui.es1369.js";
import { keep as o } from "./ghl-ui.es930.js";
import { keysOf as s } from "./ghl-ui.es924.js";
const g = s(d), k = s(h), v = s(a);
function P(r) {
  return r.type === "divider" || r.type === "render";
}
function x(r) {
  return r.type === "divider";
}
function F(r, p) {
  const {
    rawNode: e
  } = r, {
    show: l
  } = e;
  if (l === !1)
    return null;
  if (P(e))
    return x(e) ? i(O, Object.assign({
      key: r.key
    }, e.props)) : null;
  const {
    labelField: c
  } = p, {
    key: n,
    level: u,
    isGroup: f
  } = r, t = Object.assign(Object.assign({}, e), {
    title: e.title || e[c],
    extra: e.titleExtra || e.extra,
    key: n,
    internalKey: n,
    // since key can't be used as a prop
    level: u,
    root: u === 0,
    isGroup: f
  });
  return r.children ? r.isGroup ? i(m, o(t, g, {
    tmNode: r,
    tmNodes: r.children,
    key: n
  })) : i(y, o(t, v, {
    key: n,
    rawNodes: e[p.childrenField],
    tmNodes: r.children,
    tmNode: r
  })) : i(b, o(t, k, {
    key: n,
    tmNode: r
  }));
}
export {
  x as isDividerNode,
  P as isIgnoredNode,
  F as itemRenderer
};
